export default {
    "enabled": true,
    "events": [],
    "card_section": {
        "showName": "Каскадирование",
        "emptyText": "Нет назначенных целей",
        "columns": [
            {
                "label": "Название",
                "prop": "model.name"
            },
            {
                "label": "В карте",
                "width": 160,
                "template": "modules/cascading/components/CascadingCardSection/tableColumnTemplates/CascadingElementInCardTableColumn",
                "bind": {
                    "scope": "scope",
                    "card": "card"
                }
            },
            {
                "label": "Вес",
                "width": 70,
                "template": "modules/cascading/components/CascadingCardSection/tableColumnTemplates/CascadingElementWeightTableColumn",
                "bind": {
                    "scope": "scope"
                }
            },
            {
                "label": "Значение",
                "width": 200,
                "template": "modules/cascading/components/CascadingCardSection/tableColumnTemplates/CascadingScalePerformanceValuesInputTableColumn",
                "bind": {
                    "scope": "scope",
                    "performance-value-name": "'value'"
                }
            },
            {
                "label": "Ед.изм. / Тип шкалы",
                "width": 200,
                "template": "modules/cascading/components/CascadingCardSection/tableColumnTemplates/CascadingElementScaleUnitTableColumn",
                "bind": {
                    "scope": "scope"
                }
            },
            {
                "label": "Базовое",
                "width": 200,
                "template": "modules/cascading/components/CascadingCardSection/tableColumnTemplates/CascadingScalePerformanceValuesInputTableColumn",
                "bind": {
                    "scope": "scope",
                    "performance-value-name": "'baseline'"
                }
            },
            {
                "label": "Целевое",
                "width": 200,
                "template": "modules/cascading/components/CascadingCardSection/tableColumnTemplates/CascadingScalePerformanceValuesInputTableColumn",
                "bind": {
                    "scope": "scope",
                    "performance-value-name": "'target'"
                }
            },
            {
                "label": "Прогресс",
                "width": 80,
                "prop": "model.progress"
            },
            {
                "label": "% премии",
                "width": 80,
                "prop": "model.card_bonus"
            },
            {
                "label": "",
                "width": 47,
                "template": "modules/cascading/components/CascadingCardSection/tableColumnTemplates/CascadingElementActionsTableColumn",
                "bind": {
                    "scope": "scope"
                }
            }
        ]
    }
}